export type BackgroundEraserFormValues = {
  bgApiKey: string;
  aiApiKey: string;
  bgRemovalStrategy: string;
  automaticBackgroundRemoval: boolean;
};

export enum BackgroundRemovalStrategy {
  RemovalBgStrategy = "RemovalBgStrategy",
  RemovalAiStrategy = "RemovalAiStrategy",
}
